import { render, staticRenderFns } from "./SmallCabin.vue?vue&type=template&id=ffce126c&scoped=true"
import script from "./SmallCabin.vue?vue&type=script&lang=js"
export * from "./SmallCabin.vue?vue&type=script&lang=js"
import style0 from "./SmallCabin.vue?vue&type=style&index=0&id=ffce126c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffce126c",
  null
  
)

export default component.exports